import React from "react";
import { Outlet } from "react-router-dom";
import { DEFAULT_LOGO_URL, useBranding } from "./Branding";
import './Layout.css';

export const Layout = () => {
  const { branding } = useBranding();
  const customLogo = branding.logoUrl?.trim();

  return (
    <>
      <header>
        {customLogo ? (
          <img className="logo" alt="" src={customLogo}/>
        ) : (
          <a className="logo-link" href="https://www.mimobike.com/">
            <img className="logo" alt="Mimobike.am" src={DEFAULT_LOGO_URL}/>
          </a>
        )}
      </header>

      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <main>
        <Outlet/>
      </main>

      <footer>
        <div className='copyright'>
          Copyright 2019-{new Date().getFullYear()}. Mimo bike sharing. All rights reserved.
        </div>
      </footer>
    </>
  );
}
